export const suggestArticles = async (url, query, { signal } = {}) => {
  const params = new URLSearchParams({ query });
  const response = await fetch(`${url}?${params}`, {
    signal,
    headers: { Accept: 'application/json' },
    credentials: 'same-origin',
  });
  if (!response.ok) throw new Error(`Suggestions failed: ${response.status}`);
  const { payload } = await response.json();
  return payload;
};
